import React, { PureComponent } from 'react';
import clickOnActivateKey from '../../../utils/keyboard';
import './modal.css';
import '../form_layout/form_layout.css';

// Opt-in shared pop-up layout; unset keeps the legacy look for every other modal.
const VARIANT_CLASS = {
  form: 'custom-modal-inner-container myt-modal myt-form',
  table: 'custom-modal-inner-container myt-modal myt-modal-table myt-form'
};

export default class CustomModal extends PureComponent {
  componentDidMount() {
    if (this.props.show) {
      this.start_listner();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show && !this.props.show) {
      this.end_listner();
    } else if (!prevProps.show && this.props.show) {
      this.start_listner();
    }
  }

  keyDown = (e) => {
    if (e.keyCode === 27) {
      this.props.close();
    }
  };

  start_listner = () => {
    document.addEventListener('keydown', this.keyDown);
  };

  end_listner = () => {
    document.removeEventListener('keydown', this.keyDown);
  };

  stop_propagation = (e) => e.stopPropagation();

  render() {
    if (this.props.show) {
      const cus_inner_style =
        !!this.props.inner_style && Object.keys(this.props.inner_style).length !== 0
          ? this.props.inner_style
          : {};
      return (
        <div
          className="custom-modal-container"
          onClick={this.props.close}
          style={this.props.outer_style || {}}
        >
          {this.props?.showCloseBtn ? (
            <div
              className={`${this?.props?.isFullWidth ? 'custom-modal-inner-container-myt' : 'custom-modal-inner-container-close'} relative`}
              onClick={this.stop_propagation}
              style={cus_inner_style}
            >
              {!this.props.customClose ? (
                <img
                  className="absolute top-0"
                  src="https://images.myyogateacher.com/teacher_web_app/ic_cross@3x.svg"
                  alt="Close"
                  role="button"
                  tabIndex={0}
                  data-track="modal-close"
                  onClick={this.props.close}
                  onKeyDown={clickOnActivateKey}
                  width={12}
                />
              ) : null}
              {this.props.children}
            </div>
          ) : (
            <div
              className={
                VARIANT_CLASS[this.props.variant] ||
                `${this?.props?.isFullWidth ? 'custom-modal-inner-container-myt' : 'custom-modal-inner-container w-full max-w-[900px]'}`
              }
              onClick={this.stop_propagation}
              style={cus_inner_style}
            >
              <div
                className={`custom-modal-close-row flex ${this.props.title ? 'justify-between' : 'justify-end'}`}
              >
                {this.props.title && (
                  <div className="text-xl font-semibold mb-6">{this.props.title}</div>
                )}
                {this.props.closeIcon ? (
                  <span
                    className="cursor-pointer"
                    role="button"
                    tabIndex={0}
                    aria-label="Close"
                    data-track="modal-close"
                    onClick={this.props.close}
                    onKeyDown={clickOnActivateKey}
                  >
                    {this.props.closeIcon}
                  </span>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                    fill="currentColor"
                    className="w-6 h-6 cursor-pointer"
                    role="button"
                    tabIndex={0}
                    aria-label="Close"
                    data-track="modal-close"
                    onClick={this.props.close}
                    onKeyDown={clickOnActivateKey}
                  >
                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                  </svg>
                )}
              </div>

              {this.props.children}
            </div>
          )}
        </div>
      );
    }
    return null;
  }
}
